import React, { use, useEffect, useMemo, useRef, useState } from "react";
import StyledText from "../../components/StyledComponents/StyledText";
import ArrowIcon from "../../assets/icons/ArrowIcon";
import AMSListing, { Container } from "../../components/listing/AMSListing";
import Breadcrumb from "../../components/BreadCrumbs/Breadcrumbs";
import styled from "styled-components";
import { CorporateTheme, Theme } from "../../utils/themes";
import Avatar from "../../components/Avatar/Avatar";
import { useNavigate, useParams, useLocation, Link, useSearchParams } from "react-router-dom";
import { Button } from "../../components/form/Button";
import { Tabs } from "../../components/Tabs/Tabs";
import { copyToClipboard, getActiveTabId, handleChangeTab, Tab } from "../../utils/helper";
import ContactOverview from "./ContactOverview/ContactOverview";
import ContactPlaceHolder from "../../assets/images/organizationPlaceHolder.png";
import ContactEvents from "./ContactEvents";
import ContactCertification from "./ContactCertification";
import ContactCourses from "./ContactCourses";
import ContactFinance from "./ContactFinance";
import ContactMemberships from "./ContactMemberships";
import MailIcon from "../../assets/icons/MailIcon";
import { useGetContactAllWidgetsQuery, useGetLoginHistoryQuery, useGetMultipleRecordsQuery, usePresignedContactProfileMutation, useUpdateContactMutation } from "../../api/contactApiSlice";
import ContactCommunication from "./ContactCommunication/ContactCommunication";
import { SkeletonCell } from "../../components/SkeletonCell";
import { useTheme } from "../../middleware/ThemeContext";
import LinkExternalIcon from "../../assets/icons/LinkExternalIcon";
import TooltipStype2 from "../../assets/icons/TooltipStype2";
import EditIcon from "../../assets/icons/EditIcon";
import CustomInput from "../../components/form/CustomInput";
import LoadingCircleIcon from "../../assets/icons/LoadingCircleIcon";
import TickIcon from "../../assets/icons/TickIcon";
import CrossIcon from "../../assets/icons/CrossIcon";
import { useToast } from "../../components/toast/ToastContext";
import { Column, crmFormReference } from "../../types/types";
import NewCopyIcon from "../../assets/icons/NewCopyIcon";
import WidgetTabsCard from "../../components/WidgetTabsCard";
import { Row } from "react-bootstrap";
import AboutUser from "./AboutUser";
import { IdBadge } from "../organizations/OrganizationHeader";
import WidgetIcon from "../../assets/icons/WidgetIcon";
import { LayoutWidget } from "./ContactOverview/DND/dndTypes";
import { useReorderLayoutMutation } from "../../api/widgetApiSlice";
import { LoadingSpinner } from "../ui/LoadingSpinner";
import widgetSampleData from "./ContactOverview/DND/data.json";
import CloseIcon from "../../assets/icons/CloseIcon";
import { GridStackHandle } from "./ContactOverview/DND/GridStackExample";
import NoData from "../../components/listing/NoData";
import BulkUpdateModal from "../searchQuery/BulkUpdateModal";
import PlusIcon from "../../assets/icons/PlusIcon";
import ContactLoginActivity from "./ContactOverview/ContactLoginActivity";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import DeletePrompt from "../../components/DeletePrompt";
import { contactService } from "../../api/contactService";
import ResetIcon from "../../assets/icons/ResetIcon";
import { useSelector } from "react-redux";
import { selectAuth } from "../../features/auth/authSlice";


interface OrganizationRole {
  id: number;
  name: string;
}

interface ContactOrgRole {
  id: number;
  contactOrgId: number;
  roleId: number;
  isDeleted: boolean;
  role: OrganizationRole;
}

interface Organization {
  id: number;
  name: string;
  image: string | null;
  industry: string | null;
  createdAt: string; // ISO date string
  signedUrl: string;
}

interface ContactOrganization {
  id: number;
  contactId: number;
  organizationId: number;
  isPrimary: boolean;
  isDeleted: boolean;
  organization: Organization;
  contactOrgRoles: ContactOrgRole[];
}

interface LoginAttemptRow {
  id: number | string;
  timestamp: string;
  username: string;
  ipAddress: string;
  location: string;
  device: string;
  platform?: string;
  devicePlatform?: string;
}

type ContactData = {
  id?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  signedUrl?: string;
  contactRoles?: { id: number; role: { id: number; name: string } }[];
  organization?: { name?: string; image: string; industry: string };
  contactOrganizations?: ContactOrganization[]
  createdAt?: Date;
  cfr?: crmFormReference;
  source: string;
  createdBy: { firstName: string; lastName: string };
  account: { firstName: string; lastName: string };
  lastPasswordResetAt?: string;
  loginAttempts?: LoginAttemptRow[];
  // Add other fields as needed
};

type DeviceInfo = {
  os: string,
  raw: string,
  client: string,
  device: string,
  isBotLike: boolean
}

type Events = {
    id: number,
    contactId: number,
    companyId: number,
    actorType: string,
    actorId: number,
    eventType: string,
    email: string,
    ipAddress: string,
    userAgent: string,
    deviceInfo: DeviceInfo,
    locationInfo: null,
    errorMessage: null,
    metadata: null,
    createdAt: string
}

type LoginHistoryResult = {
    contactId: number,
    email: string,
    totalEvents: number,
    page: number,
    limit: number,
    totalPages: number,
    events: Events[]
};

const FALLBACK_LOGIN_ATTEMPTS: LoginAttemptRow[] = [
  {
    id: 1,
    timestamp: "2025-10-22 17:45:10",
    username: "wahab123",
    ipAddress: "192.168.1.101",
    location: "Karachi, Pakistan",
    device: "Windows 10",
  },
  {
    id: 2,
    timestamp: "2025-10-22 17:50:32",
    username: "admin",
    ipAddress: "203.0.113.45",
    location: "Unknown",
    device: "Linux",
  },
  {
    id: 3,
    timestamp: "2025-10-22 18:02:05",
    username: "wahab123",
    ipAddress: "192.168.1.101",
    location: "Lahore, Pakistan",
    device: "Android 12",
  },
  {
    id: 4,
    timestamp: "2025-10-22 18:10:44",
    username: "test_user",
    ipAddress: "198.51.100.23",
    location: "Karachi, Pakistan",
    device: "macOS",
  },
  {
    id: 5,
    timestamp: "2025-10-22 17:45:10",
    username: "wahab123",
    ipAddress: "192.168.1.101",
    location: "Karachi, Pakistan",
    device: "Windows 10",
  },
  {
    id: 6,
    timestamp: "2025-10-22 17:50:32",
    username: "admin",
    ipAddress: "203.0.113.45",
    location: "Unknown",
    device: "Linux",
  },
  {
    id: 7,
    timestamp: "2025-10-22 18:02:05",
    username: "wahab123",
    ipAddress: "192.168.1.101",
    location: "Lahore, Pakistan",
    device: "Android 12",
  },
  {
    id: 8,
    timestamp: "2025-10-22 18:10:44",
    username: "test_user",
    ipAddress: "198.51.100.23",
    location: "Karachi, Pakistan",
    device: "macOS",
  },
  {
    id: 9,
    timestamp: "2025-10-22 18:10:44",
    username: "test_user",
    ipAddress: "198.51.100.23",
    location: "Karachi, Pakistan",
    device: "macOS",
  },
  {
    id: 10,
    timestamp: "2025-10-22 18:02:05",
    username: "wahab123",
    ipAddress: "192.168.1.101",
    location: "Lahore, Pakistan",
    device: "Android 12",
  },
];

const NOOP = () => undefined;

const ContactPreview = () => {
  const { theme } = useTheme();
  const auth = useSelector(selectAuth);
  const { id } = useParams();

  const showToast = useToast();
  const [copied, setCopied] = useState(false);
  const location = useLocation();
  // const scope = location?.state?.scope;
  const scope =
    new URLSearchParams(location.search).get("scope") ??
    location.state?.scope;
  const from = new URLSearchParams(location.search).get("from") ?? location.state?.from;
  const [editName, seteditName] = useState(false);
  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [imageKey, setImageKey] = useState<string>();
  const { data, refetch, isLoading, error } = useGetMultipleRecordsQuery(id, { refetchOnMountOrArgChange: true, });

  const [updateFirstLastName, { isLoading: isLoadingName }] = useUpdateContactMutation();
  const [imagePreSignedUrl, { isLoading: imageLoading }] = usePresignedContactProfileMutation();
  const { data: widgetData, refetch: widgetRefetch, isLoading: widgetLoading, isFetching: widgetFetching } = useGetContactAllWidgetsQuery({ id, scope }, { refetchOnMountOrArgChange: true, refetchOnFocus: true });
  const [isManagingLayout, setIsManagingLayout] = useState(false);
  const contactData: ContactData = data ? data[0] : [];
  const [widget, setWidget] = useState<any[]>([]);
  const [originalWidgets, setOriginalWidgets] = useState<any[]>([]);
  const [reorder, { isLoading: reorderLoading }] = useReorderLayoutMutation();
  const gridRef = useRef<GridStackHandle>(null);
  const [showBulkUpdateModal, setShowBulkUpdateModal] = useState(false);
  const [showContactDeletePopup, setShowContactDeletePopup] = useState(false);
  const [showAccountSettings, setShowAccountSettings] = useState(false);
  const [portalAccessStatus, setPortalAccessStatus] = useState<string | null>(null);
  const [portalAccessLoading, setPortalAccessLoading] = useState(false);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
  });

  const {data: getLoginHistoryResult, isLoading: isLoginHistoryLoading, refetch: refetchLoginHistory} = useGetLoginHistoryQuery(id, { skip: !id });
  
  // useEffect(() => {
  //   if (widgetSampleData?.widgets?.length > 0) {
  //     setTimeout(() => {
  //       setWidget(widgetSampleData?.widgets);
  //     }, 3000);
  //   }
  // }, [widgetSampleData?.widgets?.length]);

  // useEffect(() => {
  //   if (widgetData?.widgets?.length > 0) {
  //     setWidget(widgetData.widgets);
  //   }
  // }, [widgetData?.widgets]);

  const confirmDelete = async () => {
    if (!id) return;

    setShowContactDeletePopup(false);

    try {
      if (id) {
        const numericId = Number(id);
        await contactService.deleteContact(numericId.toString());

      }

      showToast('Contact Deleted', 'The contact is deleted.', 'success');

      navigate('/home/contacts');
      // if(from === '/merge'){
      //   navigate('/home/contacts');
      // } else {
      //   navigate(-1);
      // }
    } catch (error) {
      console.error('Delete failed:', error);
      showToast('Delete Failed', 'Failed to delete contact. Please try again.', 'error');
    } finally {

    }
  };

  useEffect(() => {
    if (widgetData?.widgets?.length > 0) {
      setWidget(widgetData.widgets);
      // 🔥 Jab data load ho to backup bhi save karein
      if (!isManagingLayout) {
        setOriginalWidgets(widgetData.widgets);
      }
    }
  }, [widgetData?.widgets, isManagingLayout]);

  useEffect(() => {
    refetch();
    widgetRefetch();
  }, [id]);



  // useEffect(() => {
  //   if (widgetSampleData?.widgets?.length > 0) {
  //     setWidget(widgetSampleData?.widgets);
  //   }
  // }, [widgetSampleData?.widgets?.length]);

  const breadcrumbItems = [
    { label: "Contact Listing", href: "/home/contacts" },
    { label: "Contact Overview", active: true },
  ];

  const productTabs = [
    {
      id: 1,
      title: "Contact Overview",
      active: true,
    },
    {
      id: 2,
      title: "Notes",
      active: false,
    },
  ];

  const [tabs, setTabs] = useState<Tab[]>(productTabs);
  const onChangeTabs = (tab: number) => {
    const updatedTabs = handleChangeTab(tabs, tab);
    setTabs(updatedTabs);
    const query = scope ? `?scope=${encodeURIComponent(scope)}` : "";

    if (tab === 1) {
      navigate(`/home/contacts/${id}${query}`);
    } else if (tab === 2) {
      navigate(`/home/contacts/${id}/notes${query}`);
    } else {
      navigate(`/home/contacts/${id}`);
    }
  };

  // const handleCancel = () => {
  //   gridRef.current?.onCancel();
  //   widgetRefetch();

  // }

  const handleCancel = () => {
    // 🔥 PEHLE state restore karein (component mount rakho)
    if (originalWidgets && originalWidgets.length > 0) {
      setWidget(originalWidgets);
    }

    // 🔥 PHIR grid ka onCancel call karein
    setTimeout(() => {
      gridRef.current?.onCancel();
      setIsManagingLayout(false);
    }, 0);

    // 🔥 End mein refetch (optional - agar server se fresh data chahiye)
    // widgetRefetch(); // Ye mat karein immediately, nahi to loading state aa jayega
  };

  const fetchPortalAccessStatus = async () => {
    if (!contactData?.id) return;

    try {
      setPortalAccessLoading(true);
      const statusResponse = await contactService.getPortalAccessStatus(contactData.id);
      let status: string | null = null;

      if (statusResponse) {
        const { hasPortalAccess, portalStatusId } = statusResponse as any;

        // Treat revoked status as REVOKED even if hasPortalAccess is false,
        // so that Reactivate action can be enabled in that scenario.
        if (portalStatusId === 3 && hasPortalAccess === false) {
          status = "REVOKED";
        } else if (!hasPortalAccess) {
          status = "NO_ACCESS";
        } else if (portalStatusId === 65) {
          status = "INVITED";
        } else if (portalStatusId === 16) {
          status = "ACTIVE";
        } else if (portalStatusId === 3) {
          status = "REVOKED";
        } else {
          status = "UNKNOWN";
        }
      }

      setPortalAccessStatus(status);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch portal access status.";
      showToast("Error", message, "error");
      setPortalAccessStatus(null);
    } finally {
      setPortalAccessLoading(false);
    }
  };

  const handleAccountSettingsClick = async () => {
    if (!showAccountSettings && isManagingLayout) {
      handleCancel();
    }
    const next = !showAccountSettings;
    setShowAccountSettings(next);

    if (next) {
      await fetchPortalAccessStatus();
    }
  };

  const handleResetPassword = async () => {
    if (!contactData?.id) return;

    try {
      await contactService.resetPortalPassword(contactData.id);
      showToast(
        "Password Reset",
        "Password reset initiated successfully.",
        "success"
      );
      await fetchPortalAccessStatus();
      refetch();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to reset password. Please try again.";

      showToast("Error", message, "error");
    }
  };

  const handleRevokeAccess = async () => {
    if (!contactData?.id) return;

    try {
      await contactService.suspendPortalAccess(contactData.id);
      showToast(
        "Access Revoked",
        "Portal access has been revoked for this contact.",
        "success"
      );
      await fetchPortalAccessStatus();
      refetch();
      refetchLoginHistory();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to revoke access. Please try again.";

      showToast("Error", message, "error");
    }
  };

  const handleGrantAccess = async () => {
    if (!contactData?.id) return;

    try {
      await contactService.grantPortalAccess(contactData.id);
      showToast(
        "Access Granted",
        "Portal access has been granted to this contact.",
        "success"
      );
      await fetchPortalAccessStatus();
      refetch();
      refetchLoginHistory();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to grant access. Please try again.";

      showToast("Error", message, "error");
    }
  };

  const handleResendInvitation = async () => {
    if (!contactData?.id) return;

    try {
      await contactService.resendPortalInvite(contactData.id);
      showToast(
        "Invitation Sent",
        "Invitation has been resent to the contact.",
        "success"
      );
      await fetchPortalAccessStatus();
      refetch();
      refetchLoginHistory();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to resend invitation. Please try again.";

      showToast("Error", message, "error");
    }
  };

  const handleForceLogin = async () => {
    if (!contactData?.id) return;

    // showToast(
    //   "Force Login",
    //   "Force Login initiated successfully.",
    //   "success"
    // );
    try {
      const response = await contactService.forceLoginPortalAccess(contactData.id);

      // Get current user's full name from Redux auth state
      const currentUserViewerName = `${auth?.firstName || ''} ${auth?.lastName || ''}`.trim() || auth?.email || 'Admin';

      const authData = btoa(JSON.stringify({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
        expiresIn: response.expiresIn,
        cognitoId: response.cognitoId,
        email: response.email,
        userId: response.userId,
        company: response.company,
        firstName: response.firstName,
        lastName: response.lastName,
        fullName: response.fullName,
        organizationId: response.organizationId,
        domain: response.domain,
        contactSignedUrl: response.contactSignedUrl,
        userSignedUrl: response.userSignedUrl,
        viewerName: currentUserViewerName,
      }));

      // redirect to target domain
      // window.location.href = `https://${response.domain}/force-login?token=${authData}`;
      window.open(`https://${response.domain}/force-login?token=${authData}`, '_blank', 'noopener,noreferrer');
      // showToast(
      //   "Force Login",
      //   "Portal access has been reactivated for this contact.",
      //   "success"
      // );
      refetch();
      refetchLoginHistory();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to force login. Please try again.";

      showToast("Error", message, "error");
    }
  };

  const handleReactivate = async () => {
    if (!contactData?.id) return;

    try {
      await contactService.reactivatePortalAccess(contactData.id);
      showToast(
        "Reactivated",
        "Portal access has been reactivated for this contact.",
        "success"
      );
      await fetchPortalAccessStatus();
      refetch();
      refetchLoginHistory();
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to reactivate access. Please try again.";

      showToast("Error", message, "error");
    }
  };
  const isPortalNoAccess = portalAccessStatus === "NO_ACCESS";
  const isPortalInvited = portalAccessStatus === "INVITED";
  const isPortalActive = portalAccessStatus === "ACTIVE";
  const isPortalRevoked = portalAccessStatus === "REVOKED";

  const portalStatusLabel =
    portalAccessStatus === "NO_ACCESS"
      ? "No Access"
      : portalAccessStatus === "INVITED"
        ? "Invited"
        : portalAccessStatus === "ACTIVE"
          ? "Active"
          : portalAccessStatus === "REVOKED"
            ? "Revoked/Suspended"
            : portalAccessStatus === "UNKNOWN"
              ? "Unknown"
              : portalAccessStatus || "";

  useEffect(() => {
    if (location.pathname.includes("notes")) {
      // setTabs(handleChangeTab(tabs, 2));
      setTabs(prevTabs => handleChangeTab(prevTabs, 2));
    } else {
      setTabs(prevTabs => handleChangeTab(prevTabs, 1));
    }
    // else if (!location.pathname.endsWith(id?.toString() ?? "")) {
    //   navigate(`/home/contacts/${id}`, { replace: true });
    // }



    // else navigate(`/home/contacts/${id}`);

  }, [location?.pathname]);

  const activeTab = getActiveTabId(tabs);

  const navigate = useNavigate();
  const theLocation = useLocation();

  useEffect(() => {
    if (contactData) {
      setFirstName(contactData?.firstName);
      setLastName(contactData?.lastName)
    }
  }, [contactData]);

  const updateName = () => {

    if(!firstName?.trim()){
      setErrors((prev) => ({
        ...prev,
        firstName: "First name is required",
      }));
    }

    if(!lastName?.trim()) {
      setErrors((prev) => ({
        ...prev,
        lastName: "Last name is required",
      }));
    } 

    if(!firstName?.trim() || !lastName?.trim()){
      return;
    }

    const value = {
      id: contactData.id,
      contactMeta: {
        firstName: firstName,
        lastName: lastName,
        ...(imageKey ? { image: imageKey } : {}),
      },
    };
    updateFirstLastName(value)
      .unwrap()
      .then((res) => {
        if (res?.error) {
          showToast(
            "Error",
            res?.error?.data?.message || "Failed to update name",
            "error"
          );
          return;
        }
        showToast("Successfully", "Name updated successfully", "success");
        seteditName(false);
        refetch && refetch();
        widgetRefetch && widgetRefetch();
      });

  }

  const updateImage = (imageKey?: string) => {
    const value = {
      id: contactData.id,
      contactMeta: {
        ...(imageKey ? { image: imageKey } : {}),
      },
    };
    updateFirstLastName(value)
      .unwrap()
      .then((res) => {
        if (res?.error) {
          showToast(
            "Error",
            res?.error?.data?.message || "Failed to update image",
            "error"
          );
          return;
        }
        showToast("Successfully", "Profile image updated successfully", "success");
        refetch && refetch();
        widgetRefetch && widgetRefetch();
      });
  }

  const handleUpload = async (file: File): Promise<string> => {
    const { data } = await imagePreSignedUrl({ fileName: file.name, fileType: file.type, });
    if (!data?.url) {
      showToast("Error", 'Could not process the upload. Please make sure the file is valid and the internet connection is stable', "error");
      return "";
    }
    await fetch(data?.url, { method: data?.method, headers: { Accept: 'application/json', 'Content-Type': file.type, }, body: file });
    return data?.key;
  };

  const handleBack = () => {
    const prevUrl = theLocation.state?.from || '';

    if (prevUrl.includes("/merge")) {
      navigate("/home/contacts");
    } else {
      navigate(-1);
    }
  };

  const handleCopy = async () => {
    if (!contactData?.id) return;

    await copyToClipboard(contactData?.id);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000); // 2 seconds baad icon wapis
  };

  const PrimaryOrganization = contactData?.contactOrganizations
    ?.find((org) => org.isPrimary)?.organization;


  const OrganiztionTabsDetails = [
    {
      label: 'About this User',
      content: <AboutUser contactData={contactData} />,
    },
    {
      label: 'Last Login Activity',
      content: <ContactLoginActivity data={contactData} />
    },
  ];

  const loginAttemptsColumns = useMemo<Column[]>(() => [
    { id: "device", label: "Device/Platform" },
    // { id: "username", label: "Username" },
    { id: "ipAddress", label: "IP Address" },
    { id: "type", label: "Type" },
    // { id: "location", label: "Location" },
    { id: "createdAt", label: "Timestamp" },
  ], []);

  const loginAttemptsData = useMemo<LoginHistoryResult[]>(() => {
    const source = getLoginHistoryResult?.events && getLoginHistoryResult?.events.length > 0
      ? getLoginHistoryResult.events
      : [];

    return source.map((event: any, index: any) => ({
      id: event?.id ?? index + 1,
      createdAt: event?.createdAt ?? "-",
      // username: event.username ?? "-",
      ipAddress: event?.ipAddress ?? "-",
      // location: event.location ?? "Unknown",
      type: event?.eventType ?? "-",
      device: event?.deviceInfo?.client && event?.deviceInfo?.os
              ? `${event.deviceInfo.client} / ${event.deviceInfo.os}`
              : "-",
    }));
  }, [getLoginHistoryResult?.events]);

  const loginAttemptsLoading = isLoginHistoryLoading && !(getLoginHistoryResult as any)?.events?.length;

  const formattedLastPasswordReset = useMemo(() => {
    if (!contactData?.lastPasswordResetAt) {
      return "Not available";
    }

    return new Date(contactData.lastPasswordResetAt).toLocaleString("en-US", {
      day: "2-digit",
      month: "long",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }, [contactData?.lastPasswordResetAt]);


  const handleSaveChanges = async () => {
    try {
      // 1. Transform widgets to minimal, clean payload
      const widgets = widget.map((w) => ({
        widgetId: w.widgetId,
        x: w.x,
        y: w.y,
        w: w.w,
        h: w.h,
        ...(w.customTitle !== null && { customTitle: w.customTitle }),
      }));

      // 2. Call the API
      const response = await reorder({ data: { widgets: widgets }, scope }).unwrap();

      // 3. Handle success
      // Note: RTK Query's `unwrap()` throws on error, so if we reach here, it's success
      showToast("Success", "Layout updated successfully", "success");
      setIsManagingLayout(false);
      widgetRefetch();
      refetch()
    } catch (error: any) {
      // 4. Unified error handling
      const message =
        error?.data?.message ||
        error?.message ||
        "Failed to update layout. Please try again.";

      showToast("Error", message, "error");
      setIsManagingLayout(false);
    }
  };

  const handleCloseBulkUpdateModal = () => {
    setShowBulkUpdateModal(false);
  };

  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  useEffect(() => {
    if (!widgetLoading && !widgetFetching) {
      setHasLoadedOnce(true);
    }
  }, [widgetLoading, widgetFetching]);



  return (
    <Container theme={theme} className=" pt-0 " style={{ backgroundColor: 'transparent' }}>
      <div className="d-flex  justify-content-between align-items-center mt-4">
        <div className="d-flex  gap-2">
          <ArrowIcon
            className="cursor-pointer"
            onClick={handleBack}
            color={theme.CorporateTheme.colors.textSecondary}
          />
          <StyledText fontSize="16px">Back</StyledText>
        </div>
        <div className="d-flex gap-2 mb-2">
          {/* <Button theme={theme} type="submit" $variant="add">
            Edit Account
          </Button> */}

          {/* <Breadcrumb items={breadcrumbItems} /> */}
          {/* <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.primary}
            color={theme?.CorporateTheme?.colors?.background}
            borderColor="none"
            type="button"
            $variant="customButton"
            className={`px-3`}

            onClick={() => setShowBulkUpdateModal(true)}
          >
            <PlusIcon color={theme?.CreateFormTheme?.colors?.background} />
            Add Fields
          </Button> */}
          <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.background}
            color={theme?.CorporateTheme?.colors?.headerColor}
            type="button"
            borderColor={theme?.CorporateTheme?.colors?.border}
            width="42px"
            $variant="customButton"
            className={`px-3`}
            btnPadding="1px !important"
            onClick={() => setShowContactDeletePopup(true)}
          >
            <DeleteIcon />
            {/* Delete Contact */}
          </Button>
          <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.count}
            color={theme?.CorporateTheme?.colors?.background}
            borderColor="none"
            type="button"
            $variant="customButton"
            className={`px-3`}

            onClick={() => {
              if (isManagingLayout) {
                handleSaveChanges();
              }
              setOriginalWidgets(widgetData?.widgets);
              setIsManagingLayout(true);
            }}
          >
            {(isManagingLayout && reorderLoading) ? <LoadingSpinner color={theme?.CreateFormTheme?.colors?.background} size="18px" /> : <WidgetIcon color={theme?.CreateFormTheme?.colors?.background} />}
            {isManagingLayout ? "Save Changes" : "Manage Layout"}
          </Button>

          {isManagingLayout ? <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.primary}
            color={theme?.CorporateTheme?.colors?.background}
            type="button"
            borderColor="none"
            $variant="customButton"
            className={`px-3`}
            onClick={() => {

              handleCancel();

            }}
          >
            {<CloseIcon color={theme?.CreateFormTheme?.colors?.background} />}
            Cancel Changes
          </Button> : null}
          {/* {portalAccessStatus === 'ACTIVE' &&
          <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.count}
            color={theme?.CorporateTheme?.colors?.background}
            borderColor="none"
            type="button"
            $variant="customButton"
            className={`px-3`}
            onClick={handleForceLogin}
          // disabled={portalAccessLoading || !isPortalActive}
          >
            Force Login
          </Button>
          } */}
          <Button
            theme={theme}
            btnBg={theme?.CorporateTheme?.colors?.primary}
            color={theme?.CorporateTheme?.colors?.background}
            type="button"
            borderColor="none"

            $variant="customButton"
            className={`px-3`}
            onClick={handleAccountSettingsClick}
          >
            {showAccountSettings ? <span>
              <CloseIcon color={theme?.CreateFormTheme?.colors?.background} /> Close Account Settings
            </span> : "Account Settings"}
          </Button>

        </div>
      </div>
      <div
        className="overflow-y-auto overflow-x-hidden"
        style={{ height: "calc(100vh - 205px)" }}
      >
        {isLoading ? (
          <>
            <StyledContactBanner theme={theme}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex gap-4">
                  <SkeletonCell
                    style={{
                      width: "100px",
                      height: "100px",
                      marginBottom: "10px",
                      borderRadius: "100%",
                    }}
                  />
                  <div className="d-flex flex-column">
                    <SkeletonCell
                      style={{
                        width: "100px",
                        height: "20px",
                        marginBottom: "10px",
                      }}
                    />
                    <SkeletonCell
                      style={{
                        width: "200px",
                        height: "20px",
                        marginBottom: "5px",
                      }}
                    />
                    <div className="d-flex mt-2 gap-2">
                      {Array(4).fill(null).map((_, i) => (
                        <SkeletonCell
                          style={{
                            width: "100px",
                            height: "32px",
                            marginBottom: "5px",
                            borderRadius: "50px",
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-3">
                  {Array(2)
                    .fill(null)
                    .map((_, i) => (
                      <SkeletonCell
                        style={{
                          width: "280px",
                          height: "110px",
                          marginBottom: "10px",
                        }}
                      />
                    ))}
                </div>
              </div>

              <div className="d-flex gap-1 align-items-center">
                {Array(2)
                  .fill(null)
                  .map((_, i) => (
                    <SkeletonCell
                      style={{
                        width: "80px",
                        height: "20px",
                        marginTop: "30px",
                      }}
                    />
                  ))}
              </div>
            </StyledContactBanner>
          </>
        ) : (
          <StyledContactBanner theme={theme}>
            <Row>
              <div className="d-flex align-items-center gap-4 col-6">
                {/* <Avatar
                    name={contactData?.firstName + " " + contactData?.lastName}
                    imageUrl={contactData?.signedUrl ?? ""}
                    size={150}
                  /> */}
                <div>
                  <Avatar
                    name={contactData?.firstName + " " + contactData?.lastName}
                    imageUrl={contactData?.signedUrl}
                    size={150}
                    border={`5px solid #FFFFFF`}
                    enableUpload
                    onUpload={handleUpload}
                    handleUpdate={updateImage}
                    loading={imageLoading}
                  />
                </div>
                <div className="d-flex flex-column">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="d-flex gap-3">
                      {!editName ?
                        <>
                          <StyledText
                            fontSize="20px"
                            fontWeight={700}
                            textColor={theme.CorporateTheme?.colors?.primary}
                          >
                            {contactData?.firstName + " " + contactData?.lastName}
                          </StyledText>
                          <EditIcon className="cursor-pointer" color={theme.CorporateTheme.colors.gunmetal} strokeWidth={1.5} onClick={() => seteditName(true)} />

                        </>
                        :
                        <>
                          <div className="d-flex gap-2">
                            <div>
                            <CustomInput
                              value={firstName || ""}
                              onChange={(value) => {
                                setFirstName(value);
                                setErrors((prev) => ({
                                  ...prev,
                                  firstName: "",
                                }));
                              }}
                              placeholder={'First Name'}
                              type='text'
                              error={errors.firstName}
                            />
                            </div>
                            <div>
                            <CustomInput
                              value={lastName || ""}
                              onChange={(value) => {
                                setLastName(value);
                                setErrors((prev) => ({
                                  ...prev,
                                  lastName: "",
                                }));
                              }}
                              placeholder={'Last Name'}
                              type='text'
                              error={errors.lastName}
                            />
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-2 ">
                            {isLoadingName ? (
                              <LoadingCircleIcon color={theme.CorporateTheme.colors.secondary} />
                            ) : (
                              <TickIcon
                                className="cursor-pointer"
                                onClick={updateName}
                              />
                            )}
                            <CrossIcon
                              className={`${isLoadingName && 'class-disable'} cursor-pointer`}
                              onClick={() => {
                                seteditName(false);
                                setErrors({
                                  firstName: "",
                                  lastName: "",
                                });
                              }}
                              color={theme.CorporateTheme.colors.textSecondary}
                            />
                          </div>

                        </>
                      }
                    </div>
                    <IdBadge theme={theme} className='d-flex gap-1 align-items-center p-1 rounded-1 cursor-pointer h-25' onClick={handleCopy}>
                      <StyledText
                        fontSize="12px"
                        fontWeight={500}
                        textColor={theme.CorporateTheme?.colors?.heavyMetal}
                      >
                        {contactData?.id}
                      </StyledText>
                      {copied ? (
                        <TickIcon size={14} color={theme.CorporateTheme.colors.green} />
                      ) : (
                        <NewCopyIcon size={14} color={theme.CorporateTheme.colors.gunmetal} />
                      )}
                    </IdBadge>
                  </div>
                  <StyledText
                    fontSize="16px"
                    fontWeight={500}
                    textColor={theme.CorporateTheme?.colors?.textSecondary}
                    className="mt-2"
                  >
                    <MailIcon className="me-1 mb-1" color={theme.CorporateTheme.colors.primary} />
                    {contactData?.email}
                  </StyledText>
                  <div className="d-flex mt-2 gap-2 flex-wrap">
                    {contactData?.contactOrganizations
                      ?.filter((org) => org?.isPrimary && org?.organization?.name !== null)
                      .map((org) =>
                        org.contactOrgRoles.map((role) => (
                          <Roles
                            theme={theme}
                            key={role?.id}
                          >
                            <span
                              style={{
                                width: '8px',
                                height: '8px',
                                display: 'block',
                                borderRadius: '50%',
                                marginRight: '5px',
                                backgroundColor: theme.CorporateTheme.colors.green,
                              }}
                            ></span>
                            <StyledText
                              fontSize="16px"
                              fontWeight={500}
                              textColor={theme.CorporateTheme.colors.headerColor}
                            >
                              {role?.role?.name}
                            </StyledText>
                          </Roles>
                        ))
                      )}
                  </div>

                </div>
              </div>

              <div className="d-flex gap-3 col-6 justify-content-end">
                {/* {PrimaryOrganization && ... } */}

                {showAccountSettings ? (
                  <LoginSecurityCard theme={theme}>
                    <div className="d-flex flex-column gap-1">
                      <StyledText
                        fontSize="16px"
                        fontWeight={700}
                        textColor={theme.CorporateTheme?.colors?.headerColor}
                      >
                        Login & Security
                      </StyledText>
                      {/* <LoginSecurityStat theme={theme}>
                        Failed Login Attempts: {loginAttemptsData.length}
                      </LoginSecurityStat> */}
                      {portalAccessStatus && (
                        <LoginSecurityStat theme={theme}>
                          Portal Status: {portalStatusLabel}
                        </LoginSecurityStat>
                      )}
                    </div>
                    {/* <LoginSecurityMeta theme={theme}>
                      Last password reset on: <span>{formattedLastPasswordReset}</span>
                    </LoginSecurityMeta> */}
                    {portalAccessLoading ? (
                      <LoginSecurityActions>
                        {Array(4)
                          .fill(null)
                          .map((_, i) => (
                            <SkeletonCell
                              key={i}
                              style={{
                                width: "120px",
                                height: "32px",
                                borderRadius: "4px",
                              }}
                            />
                          ))}
                      </LoginSecurityActions>
                    ) : (
                      <LoginSecurityActions>
                        <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.count}
                          color={theme?.CorporateTheme?.colors?.background}
                          borderColor="none"
                          type="button"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleGrantAccess}
                          disabled={portalAccessLoading || !isPortalNoAccess}
                        >
                          Grant Access
                        </Button>
                        {portalAccessStatus === 'ACTIVE' &&
                        <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.count}
                          color={theme?.CorporateTheme?.colors?.background}
                          borderColor="none"
                          type="button"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleForceLogin}
                        // disabled={portalAccessLoading || !isPortalActive}
                        >
                          Force Login
                        </Button>
                        }
                        {/* <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.primary}
                          color={theme?.CorporateTheme?.colors?.background}
                          type="button"
                          borderColor="none"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleResetPassword}
                          disabled={portalAccessLoading || !isPortalActive}
                        >
                          {<CloseIcon color={theme?.CreateFormTheme?.colors?.background} />}
                          Reset Password
                        </Button> */}
                        <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.count}
                          color={theme?.CorporateTheme?.colors?.background}
                          borderColor="none"
                          type="button"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleRevokeAccess}
                          disabled={portalAccessLoading || !isPortalActive}
                        >
                          Suspend/Revoke
                        </Button>
                        <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.primary}
                          color={theme?.CorporateTheme?.colors?.background}
                          type="button"
                          borderColor="none"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleReactivate}
                          disabled={portalAccessLoading || !isPortalRevoked}
                        >
                          Reactivate
                        </Button>
                        <Button
                          theme={theme}
                          btnBg={theme?.CorporateTheme?.colors?.primary}
                          color={theme?.CorporateTheme?.colors?.background}
                          type="button"
                          borderColor="none"
                          $variant="customButton"
                          className={`px-3`}
                          onClick={handleResendInvitation}
                          disabled={portalAccessLoading || !isPortalInvited}
                        >
                          {<ResetIcon color={theme.CorporateTheme.colors.background} />}
                          Resend Invite
                        </Button>
                      </LoginSecurityActions>
                    )}

                  </LoginSecurityCard>
                ) : (
                  <OrganizationCardDetails>
                    <WidgetTabsCard tabs={OrganiztionTabsDetails} border="none" tabFontSize="12px" paddingTop="12px" noBoxShadow />
                  </OrganizationCardDetails>
                )}

                {/* <div className="d-flex flex-column p-3 px-4 rounded-1 py-3 " style={{ backgroundColor: theme.colors.contentBackground }}>
                  <StyledText
                    fontSize="16px"
                    fontWeight={700}
                    textColor={theme.CorporateTheme?.colors?.headerColor}
                    style={{ marginBottom: '5px' }}
                  >
                    Creation Detail
                  </StyledText>
                  <div className="d-flex flex-column mt-2 gap-1 ">
                    <StyledText
                      fontSize="14px"
                      fontWeight={400}
                      textColor={theme.CorporateTheme?.colors?.lightSecondary}
                      style={{ marginBottom: '10px' }}
                    >
                      <strong>Created By: </strong>
                      {
                        contactData?.createdBy
                          ? `${contactData.createdBy?.firstName} ${contactData.createdBy?.lastName}`
                          : contactData?.account
                            ? `${contactData.account?.firstName} ${contactData.account?.lastName}`
                            : ""
                      }
                    </StyledText>
                    <StyledText
                      fontSize="14px"
                      fontWeight={400}
                      textColor={theme.CorporateTheme?.colors?.lightSecondary}
                      style={{ marginBottom: '10px' }}
                    >
                      <strong>Creation Date: </strong>
                      {new Date(contactData?.createdAt ?? "").toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )}
                    </StyledText>
                    <StyledText
                      fontSize="14px"
                      fontWeight={400}
                      textColor={theme.CorporateTheme?.colors?.lightSecondary}
                      style={{ marginBottom: '10px' }}
                    >
                      <strong>Time: </strong>
                      {new Date(contactData?.createdAt ?? "").toLocaleString(
                        "en-US",
                        {
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        }
                      )}
                    </StyledText>
                    <InfoBox theme={theme}>

                      <StyledText
                        fontSize="14px"
                        fontWeight={500}
                        color={theme.CorporateTheme.colors.headerColor}
                        style={{ fontStyle: 'italic' }}
                        htmlTag={'span'}>
                        Source: {contactData?.source}
                      </StyledText>
                    </InfoBox>
                  </div>
                </div> */}

              </div>
            </Row>

            {!showAccountSettings && (
              <Tabs mainClass="mt-4 " tabs={tabs} onChangeTabs={onChangeTabs} />
            )}
          </StyledContactBanner>
        )}
        <div>
          {showAccountSettings ? (
            <AMSListing
              title="Failed Login Attempts"
              subtitle="Review suspicious account activity for this contact."
              columns={loginAttemptsColumns}
              data={loginAttemptsData}
              totalItems={loginAttemptsData.length}
              loading={loginAttemptsLoading}
              routeKey="contact_login_attempts"
              showAdvanceSearch={false}
              showFilters={false}
              showDateRangeFilter={false}
              showActions={false}
              noTableAction
              hideActionColumn
              showPagination={false}
              onAction={NOOP}
              containerHeight={420}
              noDataTitle="No Login History Found"
              noDataSubtitle="No Login History Found against the current user"
            />
          ) : activeTab === 2 && !!location.pathname.includes("notes") ? (
            <ContactCommunication refetch={refetch} />
          ) :
            (widgetLoading || widgetFetching || !hasLoadedOnce) ? (
              // 🔹 LOADING STATE
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center">
                {Array(4).fill(null).map((_, i) => (
                  <SkeletonCell
                    key={i}
                    style={{
                      width: "32%",
                      height: "250px",
                      marginBottom: "5px",
                      borderRadius: "8px",
                    }}
                  />
                ))}
              </div>
            ) : widget?.length === 0 ? (
              // 🔹 ZERO STATE
              <div className="d-flex flex-column align-items-center">
                <NoData
                  title={"No Widget Found"}
                  subtitle={"No widget available for this contact."}
                  containerHeight={500}
                />
              </div>
            ) : (
              // 🔹 DATA STATE
              <ContactOverview
                ref={gridRef}
                data={contactData}
                refetch={refetch}
                isLoading={isLoading}
                isManagingLayout={isManagingLayout}
                backUpWidgets={originalWidgets}
                setIsManagingLayout={setIsManagingLayout}
                widget={widget}
                setWidget={setWidget}
                widgetRefetch={widgetRefetch}
                scope={scope}
                userDataRefetch={refetch}
              />
            )
          }

        </div>
      </div>
      <BulkUpdateModal show={showBulkUpdateModal} onClose={handleCloseBulkUpdateModal} scope={scope} recordIds={id ? [Number(id)] : []} refetch={widgetRefetch} />
      {showContactDeletePopup &&
        <DeletePrompt onConfirm={confirmDelete} onCancel={() => setShowContactDeletePopup(false)} />
      }
    </Container>
  );
};

export default ContactPreview;

const StyledContactBanner = styled.div`
  background-color: ${({ theme }) => theme.CorporateTheme.colors?.bannerBg};
  border-radius: 4px;
  padding: 16px 16px 0px 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 30px;
  gap: 5px;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.infoBoxBG};
`;

const OrganizationCard = styled.div`
  width: 364px;
`;

const OrganizationCardDetails = styled.div`
  width: 306px;
`;


const Roles = styled.div<{ theme: Theme }>`
 display: flex;
 align-items: center;
 justify-content: center;
 border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  padding: 7px 12px;
  border-radius: 50px;
`;

const LoginSecurityCard = styled.div`
  width: 100%;
  max-width: 460px;
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 18px 35px rgba(13, 35, 73, 0.08);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LoginSecurityMeta = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.CorporateTheme.colors.textSecondary};
  margin: 4px 0 8px;

  span {
    color: ${({ theme }) => theme.CorporateTheme.colors.primary};
    font-weight: 700;
  }
`;

const LoginSecurityActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const LoginSecurityStat = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.CorporateTheme.colors.count};
`;
